import React from 'react';
import { toast, Slide } from 'react-toastify';
import {
    TOAST_INFO, TOAST_WARNING, TOAST_SNACKBAR,
    TOAST_ERROR, TOAST_CLEAR, TOAST_SUCCESS,
    SHOW_OVERLAY, HIDE_OVERLAY, GET_MAP_EG_LIST
} from '../constants/action-types';

const initialState = {
    options: {
        className: 'custom-toast',
        autoClose: 4000,
        position: "top-right"
    },
    snackbar: 0,
    overlay: {
        show: false,
        text: "loading..."
    }
};

export default (state = initialState, action) => {
    const { type, message, options } = action;
    switch (type) {
        case TOAST_SUCCESS:
            if (message)
                toast.success(<ToastContent message={message} type='success' />,
                    { ...initialState.options, className: 'toast-success', ...options });
            break;
        case TOAST_INFO:
            if (message)
                toast.info(<ToastContent message={message} type='info' />,
                    { ...initialState.options, className: 'toast-info', ...options });
            break;
        case TOAST_WARNING:
            if (message)
                toast.warn(<ToastContent message={message} type='warn' />,
                    { ...initialState.options, className: 'toast-warn', ...options });
            break;
        case TOAST_ERROR:
            if (message)
                toast.error(<ToastContent message={message} type='error' />,
                    { ...initialState.options, className: 'toast-error', ...options });
            break;
        case TOAST_SNACKBAR: {
            if (message) {
                toast.dismiss(`snackbar${state.snackbar}`);
                toast(<div>{message}</div>, {
                    toastId: `snackbar${state.snackbar + 1}`,
                    transition: Slide,
                    autoClose: 2000, position: "bottom-center",
                    hideProgressBar: true, closeOnClick: false,
                    className: 'toast-snackbar',
                    ...(options || {})
                });
                state = { ...state, snackbar: state.snackbar + 1 };
            }
            break;
        }
        case TOAST_CLEAR:
            toast.dismiss();
            break;
        case SHOW_OVERLAY:
            state = { ...state, overlay: { ...initialState.overlay, ...action.payload, show: true } };
            break;
        case GET_MAP_EG_LIST:
        case HIDE_OVERLAY:
            state = { ...state, overlay: { ...initialState.overlay } };
            break;
        default:
            return state;
    }

    return state;
};

const ToastContent = ({ message, type }) => {
    let icon = 'fa fa-info-circle circle-icon', color = '#006CE3';
    if (type === 'success') { icon = 'fa fa-check-circle circle-icon'; color = '#5DBE61'; }
    else if (type === 'warn') { icon = 'fa fa-exclamation-triangle triangle-icon'; color = '#EF952F'; }
    else if (type === 'error') { icon = 'fa fa-exclamation-triangle triangle-icon'; color = '#EC4D30'; }

    return (<div>
        <div className="d-flex align-items-center">
            <div className="toast-icon-outer" style={{ backgroundColor: `${color}` }}>
                <i className={`${icon} toast-icon`} aria-hidden="true" />
            </div>
                <div className="toast-message">{message}</div>
        </div>
    </div>);
};